import React, { useState, ChangeEvent } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretUp, faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import './index.scss'

interface IProps {
  updateCounts: () => void
  setLimitInput: (value: number) => void
}

const EntitlementButtons: React.FC<IProps> = (props) => {
  const [showLimitsInput, setShowLimitsInput] = useState(false)
  const [limitValue, setLimitValue] = useState('')

  const closeLimitInput = (
    <div
      id='close-limit'
      onClick={() => setShowLimitsInput(false)}
    >
      <FontAwesomeIcon
        className='fa-xs mr-3 close-limit'
        icon={faCaretUp}
      />
    </div>
  )

  const validateInput = (e: ChangeEvent<HTMLInputElement>) => {
    if (isNaN(+e.currentTarget.value)) {
      return
    }
    setLimitValue(e.currentTarget.value)
    props.setLimitInput(parseInt(e.currentTarget.value, 10))
  }

  const handleSubmit = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      props.updateCounts()
    }
  }

  const limitInput = (
    <input
      id='entitlement-count'
      data-testid='entitlementLimit'
      type='text'
      placeholder='Set an entitlement limit'
      className='w-100 mb-1'
      value={limitValue}
      onChange={validateInput}
      onKeyUp={handleSubmit}
    />
  )

  const savePermissions = (
    <button
      type='button'
      data-testid='updateCounts'
      id='entitlement-submit'
      onClick={props.updateCounts}
    >
      <span className='w-100'>
        Save permissions
        <FontAwesomeIcon
          className='fa-xs ml-2 close-limit'
          size='1x'
          color='#33abb4'
          icon={faCheckCircle}
        />
      </span>
    </button>
  )

  const limitsButton = (
    <button
      type='button'
      id='entitlement-limits'
      data-testid='limitsButton'
      onClick={() => setShowLimitsInput(true)}
    >
      <span className='w-100'>
        Limits
      </span>
    </button>
  )

  if (showLimitsInput) {
    return (
      <div
        className='w-100'
        id='showLimitsInput'
      >
        <div className='w-100 d-flex align-items-center'>
          {limitInput}
          {closeLimitInput}
        </div>
        {savePermissions}
      </div>
    )
  }

  return (
    <div className='w-100 d-flex'>
      {limitsButton}
      {savePermissions}
    </div>
  )
}

export {
  EntitlementButtons
}
